<div class="consulta-publica-container">
  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
  </div>

  <!-- Formulário de Consulta -->
  <div class="consulta-form" *ngIf="!mostrarResultado">
    <div class="consulta-header">
      <h4 class="consulta-titulo">Consulta de Inscrição e Situação Cadastral de Contribuintes</h4>
      <p class="consulta-subtitulo">
       Cidadão, esta página tem como objetivo permitir a consulta de inscrição e situação cadastral de contribuintes do Estado do Tocantins pela Internet, através do CPF ou CNPJ.
      </p>
    </div>

    <div class="form-card">
      <form [formGroup]="consultaForm">
        <div class="form-group">
          <label for="cpfCnpj" class="form-label">
            <strong>CPF ou CNPJ</strong>
          </label>
          <input
            type="text"
            class="form-control"
            id="cpfCnpj"
            formControlName="cpfCnpj"
            placeholder="Digite o CPF ou CNPJ..."
            maxlength="18"
            [disabled]="loading"
            [class.is-invalid]="cpfCnpj?.invalid && cpfCnpj?.touched"
            (keypress)="apenasNumeros($event)"
          />
          <div *ngIf="cpfCnpj?.invalid && cpfCnpj?.touched" class="invalid-feedback">
            <small *ngIf="cpfCnpj?.errors?.['required']" class="text-danger">
              Campo obrigatório
            </small>
            <small *ngIf="cpfCnpj?.errors?.['pattern']" class="text-danger">
              CPF ou CNPJ inválido
            </small>
          </div>
        </div>

        <div class="form-actions">
          <button
            class="btn btn-primary btn-consultar"
            (click)="consultar()"
            [disabled]="loading || consultaForm.invalid"
          >
            <span *ngIf="!loading">Consultar</span>
            <span *ngIf="loading">Consultando...</span>
          </button>
          <button
            class="btn btn-secondary btn-voltar"
            (click)="voltarParaHome()"
            [disabled]="loading"
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="listaIe.length > 0" class="consulta-ie">
    <div class="resultado-header">
      <h1 class="resultado-titulo">Lista de Inscrições Estaduais</h1>
      <p class="resultado-subtitulo">Selecione uma Inscrição Estadual</p>
    </div>

    <div class="resultado-card widthTableIe">
      <table>
        <thead>
          <tr>
            <th>Inscrição Estadual</th>
            <th>Razão Social</th>
            <th class="coluna-selecao">Selecionar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaIe; let i = index" class="linhaSelecionavel" (click)="selecionarInscricao(i)">
            <td>{{ item.inscricaoEstadual }}</td>
            <td>{{ item.razaoSocial }}</td>
            <td class="coluna-selecao">
              <input 
                type="radio" 
                [id]="'ie-radio-' + i" 
                name="inscricaoSelecionada" 
                [checked]="inscricaoSelecionadaIndex === i"
                (change)="selecionarInscricao(i)"
              
              />
              <label [for]="'ie-radio-' + i" class="radio-label"></label>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="acoes-tabela">
        <button class="btn btn-primary btn-prosseguir" (click)="prosseguir()">
          Prosseguir
        </button>
      </div>
    </div>

  </div>

  <div class="consulta-resultado" *ngIf="mostrarResultado && dadosIE">
    <div class="resultado-header">
      <h1 class="resultado-titulo">Comprovante de Inscrição Estadual</h1>
      <p class="resultado-subtitulo">Secretaria da Fazenda - Estado do Tocantins</p>
    </div>

    <div class="resultado-card">
      <div class="secao-dados">
        <h3 class="secao-titulo">Dados Principais</h3>
        <div class="dados-grid">
          <div class="dado-item">
            <span class="dado-label">Inscrição Estadual:</span>
            <span class="dado-valor">{{ dadosIE.inscricaoEstadual }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">CPF/CNPJ:</span>
            <span class="dado-valor">{{ dadosIE.cpfCnpj }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Razão Social:</span>
            <span class="dado-valor">{{ dadosIE.razaoSocial }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Categoria de Ocupação:</span>
            <span class="dado-valor">{{ dadosIE.categoriaOcupacao }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Situação IE:</span>
            <span class="dado-valor">{{ dadosIE.situacaoIE }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Data da Situação Cadastral da IE:</span>
            <span class="dado-valor">{{ dadosIE.dataSituacaoIE }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Situação CPF/CNPJ:</span>
            <span class="dado-valor">{{ dadosIE.situacaoCpfCnpj }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Data da Situação Cadastral do CPF/CNPJ:</span>
            <span class="dado-valor">{{ dadosIE.dataSituacaoCpfCnpj }}</span>
          </div>
        </div>
      </div>

      <div class="secao-dados" *ngIf="dadosIE.cnaes && dadosIE.cnaes.length > 0">
        <h3 class="secao-titulo">CNAEs</h3>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th>Primário</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cnae of dadosIE.cnaes">
                <td>{{ cnae.codigo }}</td>
                <td>{{ cnae.descricao }}</td>
                <td>
                  <span *ngIf="cnae.primario || dadosIE.cnaes.length === 1" class="badge badge-primary">
                    Sim
                  </span>
                  <span *ngIf="!cnae.primario && dadosIE.cnaes.length > 1" class="badge badge-secondary">
                    Não
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="secao-dados" *ngIf="dadosIE.endereco">
        <h3 class="secao-titulo">Endereço</h3>
        <div class="dados-grid">
          <div class="dado-item">
            <span class="dado-label">Logradouro:</span>
            <span class="dado-valor">{{ dadosIE.endereco.logradouro }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Número:</span>
            <span class="dado-valor">{{ dadosIE.endereco.numero }}</span>
          </div>
          <div class="dado-item" *ngIf="dadosIE.endereco.complemento">
            <span class="dado-label">Complemento:</span>
            <span class="dado-valor">{{ dadosIE.endereco.complemento }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">CEP:</span>
            <span class="dado-valor">{{ dadosIE.endereco.cep }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Bairro:</span>
            <span class="dado-valor">{{ dadosIE.endereco.bairro }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Município:</span>
            <span class="dado-valor">{{ dadosIE.endereco.municipio }}</span>
          </div>
          <div class="dado-item">
            <span class="dado-label">Estado:</span>
            <span class="dado-valor">{{ dadosIE.endereco.estado }}</span>
          </div>
        </div>
      </div>

      <div class="resultado-rodape">
        <p><strong>Data/Hora da Consulta:</strong> {{ dataHoraConsulta }}</p>
        <p><strong>Portaria SEFAZ/TO nº .../....</strong></p>
        <p class="texto-validade">
          Este documento é válido para fins de comprovação de inscrição estadual.
        </p>
      </div>

      <div class="resultado-acoes">
        <button class="btn btn-success btn-imprimir" (click)="imprimirPDF()">
          <i class="fa fa-file-pdf"></i> Imprimir Comprovante (PDF)
        </button>
        <button class="btn btn-primary btn-nova-consulta" (click)="novaConsulta()">
          Nova Consulta
        </button>
        <button class="btn btn-secondary btn-voltar" (click)="voltarParaHome()">
          Voltar
        </button>
      </div>
    </div>
  </div>
</div>
